import InfiniteSearchableSelect from '../../../../components/ui/SearchableSelect/InfiniteSearchableSelect';
import { fetchOrganisationListPage } from '../../adapters/organisationListAdapter';
import {
  getOrganisationId,
  getOrganisationLabel,
  isSameOrganisation,
  mapOrganisationToSelectOption,
} from '../../../intervene/utils/organisationSelectUtils';
import TemplateSearchableSelect from './TemplateSearchableSelect';

export default function TemplateOrganisationSearchableSelect({
  valueId = null,
  selectedOrganisation = null,
  onChange,
  pageSize = 20,
  selectVariant = 'filter',
  ...props
}) {
  return (
    <InfiniteSearchableSelect
      {...props}
      fetchPage={fetchOrganisationListPage}
      pageSize={pageSize}
      enabled
      enableSearch
      loadOnOpen
      minRemoteSearchLength={2}
      searchDebounceMs={350}
      searchStrategy="hybrid"
      injectSelectedWhileSearching={false}
      valueId={valueId}
      selectedSeed={selectedOrganisation}
      mapToOption={mapOrganisationToSelectOption}
      isSameOption={isSameOrganisation}
      getOptionId={getOrganisationId}
      getOptionLabel={getOrganisationLabel}
      isOptionEqualToValue={isSameOrganisation}
      onChange={onChange}
      SelectComponent={(selectProps) => (
        <TemplateSearchableSelect {...selectProps} variant={selectVariant} />
      )}
      placeholder={props.placeholder || 'Organisation'}
      noOptionsText="No organisations found"
    />
  );
}
